import React, { useEffect, useState } from 'react'
import { Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { modulesService } from '../../services/modules'
import FluxoN8nListaTab from './FluxoN8nListaTab'

const MODULE_NAME = 'fluxo_n8n'

const FluxoN8n: React.FC = () => {
  const [moduleTitle, setModuleTitle] = useState('Fluxo N8N')
  const [moduleDescription, setModuleDescription] = useState(
    'Catálogo versionado de fluxos JSON do n8n'
  )

  useEffect(() => {
    const loadModuleInfo = async () => {
      try {
        const result = await modulesService.getByName(MODULE_NAME)
        if (result.success && result.data) {
          if (result.data.display_name) {
            setModuleTitle(result.data.display_name)
          }
          if (result.data.description) {
            setModuleDescription(result.data.description)
          }
        }
      } catch (error) {
        console.error('Erro ao buscar informações do módulo:', error)
      }
    }

    void loadModuleInfo()
  }, [])

  return (
    <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
        <PermissionGuard
          moduleName={MODULE_NAME}
          permissionType="show"
          fallback={
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center">
                <Text size="xl" className="text-gray-500 dark:text-gray-400 mb-2">
                  Acesso Negado
                </Text>
                <Text size="sm" color="muted">
                  Você não tem permissão para acessar esta página.
                </Text>
              </div>
            </div>
          }
        >
          <div className="h-full flex flex-col">
            <div className="p-6 border-b border-gray-200 dark:border-gray-700">
              <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
                {moduleTitle}
              </Heading>
              <Text size="sm" color="muted" className="mt-2">
                {moduleDescription}
              </Text>
            </div>

            <FluxoN8nListaTab />
          </div>
      </PermissionGuard>
    </div>
  )
}

export default FluxoN8n
